import React from 'react';

const MediumToggle = ({ options, selected, onChange }) => {
  if (!options || options.length !== 2) return null;

  return (
    <div className="flex items-center justify-center ">
      <div className="flex bg-tealSnow rounded-full w-full h-8">
        {options.map((option, index) => (
          <button
            key={option}
            onClick={() => onChange(option)}
            style={{ fontSize: '12px' }}
            className={`flex-1 font-semibold tracking-wider transition-colors px-3 duration-100 uppercase
              ${index === 0 ? 'rounded-l-full' : 'rounded-r-full'}
              ${
                selected === option
                  ? 'bg-tealExtraLight3 text-white'
                  : 'bg-transparent text-blueMedium border border-bluePale'
              }
            `}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MediumToggle;
